module.exports = ".uploadImage {\n  width: 100px;\n  position: absolute; }\n\n.content-image {\n  min-width: 40px;\n  max-width: 250px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/save-image/save-image.component.scss
// module id = ./src/app/components/tools/save-image/save-image.component.scss
// module chunks = main